import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("option", { value: "Pending" }, "Pendientes", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("option", { value: "Finished" }, "Finalizadas", -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

import { ref, onMounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'StatusFilter',
  emits: ['update:status'],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const selectedStatus = ref('Pending');

// Cargar el estado guardado al montar el componente
onMounted(() => {
    const savedStatus = localStorage.getItem('selectedStatus');
    if (savedStatus) {
        selectedStatus.value = savedStatus;
        emit('update:status', savedStatus);
    }
});

const emitStatus = () => {
    // Guardar el nuevo estado en localStorage
    localStorage.setItem('selectedStatus', selectedStatus.value);
    emit('update:status', selectedStatus.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("select", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedStatus).value = $event)),
      class: "bg-white border border-gray-300 text-gray-700 text-sm rounded-lg focus:ring-green-500 focus:border-green-500 focus:ring-2 focus:outline-none block w-full p-2.5",
      onChange: emitStatus
    }, _hoisted_4, 544), [
      [_vModelSelect, selectedStatus.value]
    ])
  ]))
}
}

})